import { ValidationRule } from "../types/types.validation";

const fieldTypeValidation: Record<string, ValidationRule[]> = {
  // Булевы поля - без валидации
  boolean: [],
  bool: [],

  // Строковые поля
  string: [
    { type: "max_length", params: 500, translationKey: "validationMaxLength" }
  ],
  
  // Текстовые поля
  text: [
    { type: "max_length", params: 5000, translationKey: "validationMaxLength" }
  ],
  textarea: [
    { type: "max_length", params: 5000, translationKey: "validationMaxLength" }
  ],

  // Числовые поля
  int: [
    { type: "is_int", translationKey: "validationNumberMustBeInt" }
  ],
  integer: [
    { type: "is_int", translationKey: "validationNumberMustBeInt" }
  ],
  INT8: [
    { type: "is_int", translationKey: "validationNumberMustBeInt" }
  ],

  // Дробные числа
  double: [
    { type: "is_double", translationKey: "validationNumberMustBeDouble" }
  ],
  float: [
    { type: "is_double", translationKey: "validationNumberMustBeDouble" }
  ],
  decimal: [
    { type: "is_double", translationKey: "validationNumberMustBeDouble" }
  ],

  // Даты
  date: [
    { type: "is_date", translationKey: "validationDateFormat" }
  ],
  Date: [
    { type: "is_date", translationKey: "validationDateFormat" }
  ],

  // Время
  time: [],
  timestamp: [],
  datetime: [],

  // JSON
  json: [],

  // Пароль
  password: [
    { type: "min_length", params: 6, translationKey: "validationMinLength" }
  ],

  // Цвет
  color: [
    { type: "is_regex", params: { pattern: "^#[0-9A-Fa-f]{6}$" }, translationKey: "validationColorFormat" }
  ],

  // Файлы и селекты - без валидации
  file: [],
  fk: [],
  select: [],
  multiselect: [],

  // Автоматические поля - без валидации
  string_disabled: [],
};

export const validationRules: Record<string, Record<string, ValidationRule[]>> = {
  settings: {
    name: [
      { type: "is_required", translationKey: "validationNameRequired" },
      { type: "min_length", params: 2, translationKey: "validationMinLength" },
      { type: "max_length", params: 100, translationKey: "validationMaxLength" }
    ],
    key: [
      { type: "is_required", translationKey: "validationKeyRequired" },
      { type: "min_length", params: 2, translationKey: "validationMinLength" },
      { type: "max_length", params: 50, translationKey: "validationMaxLength" },
    //   { type: "is_regex", params: { pattern: "^[a-zA-Z0-9_-]+$" }, translationKey: "validationKeyFormat" }
    ],
    value: [
      { type: "is_required", translationKey: "validationValueRequired" },
      { type: "max_length", params: 500, translationKey: "validationMaxLength" }
    ],
    number: [
      { type: "is_int", translationKey: "validationNumberMustBeInt" }
    ],
    date: [
      { type: "is_date", translationKey: "validationDateFormat" }
    ]
  },
};


export function getValidationRulesForModule(
  tableName: string,
  fieldName: string,
  fileType?: string
): ValidationRule[] | undefined {
  const specificRules = validationRules[tableName]?.[fieldName];
  if (specificRules) {
    return specificRules;
  }

  if (fileType) {
    const typeRules = fieldTypeValidation[fileType];
    if (typeRules && typeRules.length > 0) {
      return typeRules;
    }
  }

  return undefined;
}